export enum PAYMENT_INTERVAL_TYPE {
  YEARLY = 'Yearly',
  MONTHLY = 'Monthly',
  CUSTOM = 'Custom'
}
